<template>
	<div id="app">
		<div class="cont_bg">
			<img src="./assets/image/pic_bg@2x.png" alt="" class="bg_img">
		</div>
		<headers></headers>
		<router-view></router-view>
		<foot></foot>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';

	export default {
		name: 'app',
		mounted() {
			window.addEventListener("beforeunload", () => {
				localStorage.setItem("stateInfo", JSON.stringify(this.$store.state));
			});
			if (localStorage.getItem("stateInfo")) {
				this.$store.replaceState(
					Object.assign({},
						this.$store.state,
						JSON.parse(localStorage.getItem("stateInfo"))
					)
				);
			}
			localStorage.removeItem("stateInfo");
		},
		components: {
			headers,
			foot,
		},
	}
</script>

<style>
	.bai_box{
		background: #fff;
		position: relative;
		z-index: 10;
	}
	.cont_box{
		min-height: calc(100vh - 179px);
	}
	.cont_bg{
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		
	}
	.bg_img{
		width: 100%;
	}
	
	#app {
		background: #EDF4FE;
		position: relative;
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.ld_font {
		/*font-style: oblique;*/
	}
</style>
